import { gql } from "@apollo/client";
import { ApolloClientQuery } from "./_setup";
import { createLogSession } from "../restful/logs/logs";

const GET_NOTIFICATION_PREFERENCE = gql`
    query getNotificationPreference {
        getNotificationPreference {
            ... on UserNotificationPreference {
                _id
                preferences
            }
            ... on BaseError {
                errKey
                errMsg
                errObj
            }
        }
    }
`;

const UPDATE_NOTIFICATION_PREFERENCE = gql`
    mutation updateNotificationPreference($input: UpdateNotificationPreferenceInput!) {
        updateNotificationPreference(input: $input) {
            ... on UserNotificationPreference {
                _id
                preferences
            }
            ... on BaseError {
                errKey
                errMsg
                errObj
            }
        }
    }
`;

const GET_PUSH_NOTIFICATION_TEMPLATE_CATEGORY = gql`
    query getPushNotificationTemplateCategory($filter: PushNotificationTemplateCategoryFilterInput, $limit: Int, $offset: Int, $orderBy: String) {
        getPushNotificationTemplateCategory(filter: $filter, limit: $limit, offset: $offset, orderBy: $orderBy) {
            ... on PushNotificationTemplateCategoryArray {
                data {
                    _id
                    code
                    name {
                        language
                        value
                    }
                    description {
                        language
                        value
                    }
                    iconLight
                    iconDark
                    isEnabled
                    sortOrder
                }
            }
            ... on BaseError {
                errKey
                errMsg
                errObj
            }
        }
    }
`;

export async function getNotificationPreferenceQuery() {
    return ApolloClientQuery(GET_NOTIFICATION_PREFERENCE, {}, false);
}

export async function updateNotificationPreferenceMutation(input) {
    const session = createLogSession("User", "Notification", "updateNotificationPreference");
    session.create({ description: "Updating notification preference", logData: { input } });

    try {
        const execute = await ApolloClientQuery(UPDATE_NOTIFICATION_PREFERENCE, { input }, true);
        const err = execute?.updateNotificationPreference?.__typename === "BaseError" ? execute?.updateNotificationPreference : null;
        session.create({ description: err ? "Notification preference update failed" : "Notification preference updated", status: err ? "error" : "info", logData: err ? { error: err, input } : { input } });
        return execute;
    } catch (e) {
        session.create({ description: "Notification preference update failed", status: "error", logData: { input, error: e } });
        throw e;
    }
}

export async function getPushNotificationTemplateCategoryQuery() {
    return ApolloClientQuery(
        GET_PUSH_NOTIFICATION_TEMPLATE_CATEGORY,
        {
            filter: {
                isEnabled: true,
            },
            limit: null,
            offset: null,
            orderBy: "sortOrder_ASC",
        },
        false
    );
}

const CHECK_NOTIFICATION_BOT_MAPPING = gql`
    query checkNotificationBotMapping($userId: String!) {
        checkNotificationBotMapping(userId: $userId)
    }
`;

// polled while the client is in telegram, so it must not read a cached answer
export async function checkNotificationBotMappingFreshQuery(userId) {
    return ApolloClientQuery(CHECK_NOTIFICATION_BOT_MAPPING, { userId }, false, "network-only");
}

export async function checkNotificationBotMappingQuery(userId) {
    return ApolloClientQuery(CHECK_NOTIFICATION_BOT_MAPPING, { userId }, false);
}
